import * as React from 'react';
import Action from './Modules.Action';
import { authManage } from '../../../api';
import { message } from 'antd';
import moment from 'moment';
import { history } from 'kts-platform-frame/routes';
import { MyStore, reducers } from 'kts-platform-frame/redux';
import Filter from './UI.AuthRecord.Filter';
class ModulesAction {
    public changeTab = (e: string): void => {
        // Action.modulesState.xxx.xxx =1231;
        // Action.setModulesState();
    }
    public updateSelect = async (params: any) => {

    }
    public onDetailHandler = (record: any) => {
        history.push({ pathname: `authRecord/detail`, search: `authBatchId=${record.authBatchId}`, state: { authBatchName: record.authBatchName, batchNote: record.batchNote, authTime: moment(record.createTime).format('YYYY-MM-DD HH:mm:ss'),invoicePeriod:record.invoicePeriod,authType:record.authType } });
    }
    // public showModal = () => {
    //     Action.modulesState.record.modal = true;
    //     Action.setModulesState();
    // }
    public getData = () => {
        const { p1 } = Action.modulesState.record;
        if (p1.hasMore) {
            p1.loading=true;
            Action.setModulesState();
            authManage.AuthRecordList(this,
                {
                    pageNum: p1.pageNum,
                    pageSize: p1.pageSize,
                    companyId: MyStore.instance.getState().user.currentcompanyId,
                    ...p1.fields
                }
            ).then((response: any) => {
                const err = response.er;
                const res = response.res;
                if (err) {
                    return null;
                } else {
                    if (res) {
                        const { pageMeta } = res;
                        if (pageMeta.pageNum * pageMeta.pageSize > pageMeta.total) {
                            p1.hasMore=false;
                        }
                        p1.pageNum=p1.pageNum+1;
                        p1.total=pageMeta.total;
                        p1.loading=false;
                        p1.list = p1.list.concat(res.items);
                        Action.setModulesState();
                    }
                }
            });
        }
    }
    public mapListToPage = (pageNum: number) => {
        const { p1 } = Action.modulesState.record;
        p1.pageNum = pageNum;
        Action.setModulesState().then(() => {
            this.getData();
        });

    }
    public onSizeChange = async (pageNum: number, pageSize: number) => {
        const { p1 } = Action.modulesState.record;
        p1.pageNum = pageNum;
        p1.pageSize = pageSize;
        Action.setModulesState().then(() => {
            this.getData();
        });
    }
    public updateConfirm = () => {

    }

    public toggleFilter = () => {
        const { p1 } = Action.modulesState.record;
        p1.expand = !p1.expand;
        MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.add, {
            Components: <Filter />,
            title: '筛选'
        });
        Action.setModulesState();
    }
}
export default new ModulesAction();


// WEBPACK FOOTER //
// ./src/display/apps/AuthManage/Modules.Action.record.tsx